import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {RouterModule} from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatBadgeModule } from '@angular/material/badge';
import { MatStepperModule } from '@angular/material/stepper';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import {AvailableTablesListComponent} from './components/configuration/child-components/available-tables-list';
import { RestrictionComponent } from './components/restriction/restriction.component';
import { DestinationRenderComponent } from './components/destination-render/destination-render.component';
import { HeaderComponent } from './components/header/header.component';
import { FilterPropertyPipe } from './pipes/filter-property/filter-property.pipe';
import { IncludesPipe } from './pipes/includes/includes.pipe';
import { EnableTemplateFeaturePipe } from './pipes/enable-template-feature/enable-template-feature.pipe';
import { EnableTemplateActionsPipe } from './pipes/enable-template-actions/enable-template-actions.pipe';
import { FilterTablesPipe } from './pipes/filter-tables.pipe';
import { EnableFeaturePipe } from './pipes/enable-feature/enable-feature.pipe';



/* New modules */
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatToggleModule } from '@ngx-formly/material/toggle';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { FormlyMatSliderModule } from '@ngx-formly/material/slider';
import { NgxSliderModule } from '@rp3e11/ngx-slider';

import { NgSelectTypeComponent } from './components/ng-select-type/ng-select-type.component';
import { FormFieldsWrapperComponent } from './components/form-fields-wrapper/form-fields-wrapper.component';
import { GridFormlyCellComponent } from './components/grid-formly-cell/grid-formly-cell.component';
import { VirtualScrollGridFieldTypeComponent } from './components/virtual-scroll-grid-field-type/virtual-scroll-grid-field-type.component';
import { FilterSelectedTablePipe } from './pipes/filter-selected-table/filter-selected-table.pipe';
import { ColumnAccordionTypeComponent } from './components/column-accordion-type/column-accordion-type.component';
import { AccordionTypeComponent } from './components/accordion-type/accordion-type.component';
import { SliderTypeComponent } from './components/slider-type/slider-type.component';
import { TableSelectionFieldsWrapperComponent } from './components/table-selection-fields-wrapper/table-selection-fields-wrapper.component';
import { CustomSliderTypeComponent } from './components/custom-slider-type/custom-slider-type.component';
import { InterpolatePipe } from './pipes/interpolate/interpolate.pipe';
import { HistoryYearsTypeComponent } from './components/history-years-type/history-years-type.component';
import { environment } from '../../environments/environment';
// tslint:disable-next-line:max-line-length
import { existingIntegrationNameValidation, existingTemplateNameValidation, textWithUnderScoreValidation, textValidatorMessage, requiredValidatorMessage, regexValidatorMessage, regexValidator, cloneIntegrationNameValidation, validateUniqueMessage, validateUniqueValue, spaceValidator, spaceValidatorMessage, maxlengthValidationMessage, getObjectKeyOrString, cronValidator} from './helpers/helpers';
// import { FormAddnewsourceComponent } from './components/datasources-listing/form-addnewsource/form-addnewsource.component';

import { TokenInterceptor } from './interceptor/token.interceptor';
import { CheckboxWrapperComponent } from './components/checkbox-wrapper/checkbox-wrapper.component';
import { AccordionWrapperComponent } from './components/accordion-wrapper/accordion-wrapper.component';
import { FormAddnewsourceComponent } from './components/form-addnewsource/form-addnewsource.component';
import { ShowTableCategoryPipe } from './pipes/show-table-category/show-table-category.pipe';
import { ShowSelectedTableCategoryPipe } from './pipes/show-selected-table-category/show-selected-table-category.pipe';
import { DropdownWrapperComponent } from './components/dropdown-wrapper/dropdown-wrapper.component';
import { SectionInputTypeComponent } from './components/section-input-type/section-input-type.component';
import { RadioButtonWrapperComponent } from './components/radio-button-wrapper/radio-button-wrapper.component';
import { StepCreationHeaderComponent } from './components/step-creation-header/step-creation-header.component';
import { DndAccordionComponent } from './components/dnd-accordion/dnd-accordion.component';
import { CommonWrapperComponent } from './components/common-wrapper/common-wrapper.component';
import { ColumnRowsRendererComponent } from './components/configuration/child-components/column-rows-renderer/column-rows-renderer.component';
import { TrimStringTooltipComponent } from './components/trim-string-tooltip/trim-string-tooltip.component';
import { HasPropPipe } from './pipes/has-prop/has-prop.pipe';
import { CallbackPipe } from './pipes/callback-pipe';
// tslint:disable-next-line:max-line-length
// import { RepeatSectionTableComponent } from './components/configuration/child-components/repeat-section-table/repeat-section-table.component'
import {TableRepeatChildComponentComponent} from './components/configuration/child-components/table-repeat-child-component/table-repeat-child-component.component';
import { CustomLoadingCellRendererComponent } from './components/custom-loading-cell-renderer/custom-loading-cell-renderer/custom-loading-cell-renderer.component';
import { CustomLoadingOverlayComponent } from './components/custom-loading-overlay/custom-loading-overlay/custom-loading-overlay.component';
import { BannerComponent } from './components/banner/banner.component';
import { SafeHtmlPipe } from './pipes/safe-html/safe-html.pipe';
import { SubscriptionEventManagerComponent } from './components/subscription-event-manager/subscription-event-manager.component';
import { EnableSubscriptionFeaturePipe } from './pipes/enable-subscription-feature/enable-subscription-feature.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { SelectAllTablesPipe } from './pipes/select-all-tables.pipe';
import { GetObjectKeyOrStringPipe } from './pipes/get-object-key-or-string/get-object-key-or-string.pipe';
import { JsonParsePipe } from './pipes/json-parse/json-parse.pipe';
import { CommonToastComponent } from './components/common-toast/common-toast.component';
import { AlertsEventManagerComponent } from './components/alerts-event-manager/alerts-event-manager.component';
import { GridCellEditorComponent } from './components/grid-cell-editor/grid-cell-editor.component';
import { FrequencySelectTypeComponent } from './components/frequency-select-type/frequency-select-type.component';
import { CronFrequencyTypeComponent } from './components/cron-frequency-type/cron-frequency-type.component';
import { CommonSidebarComponent } from './components/common-sidebar/common-sidebar.component';
import { CronPluginComponent } from './components/cron-plugin/cron-plugin.component';
import { CustomCronEditorModule } from '@sarasanalytics-com/cron-editor';
// import { DatasourcesListingModule } from './components/datasources-listing/datasource-listing.module';
import { AppSwitcherComponent } from './components/app-switcher/app-switcher.component';
import { AppSwitcherService } from './services/app-switcher/app-switcher.service';
import { ChipComponent } from './components/chip/chip.component';
import { JobHeaderDatePipe } from './pipes/job-header-date/job-header-date.pipe';
import { ActionRequiredStatusComponent } from '../action-required-status/action-required-status.component';

@NgModule({
  declarations: [
    AppSwitcherComponent,
    AvailableTablesListComponent,
    RestrictionComponent,
    DestinationRenderComponent,
    HeaderComponent,
    EnableTemplateFeaturePipe,
    FilterPropertyPipe,
    IncludesPipe,
    EnableTemplateActionsPipe,
    FilterTablesPipe,
    EnableFeaturePipe,
    GridFormlyCellComponent,
    VirtualScrollGridFieldTypeComponent,
    FilterSelectedTablePipe,
    ColumnAccordionTypeComponent,
    AccordionTypeComponent,
    SliderTypeComponent,
    TableSelectionFieldsWrapperComponent,
    CustomSliderTypeComponent,
    InterpolatePipe,
    HistoryYearsTypeComponent,
    CheckboxWrapperComponent,
    AccordionWrapperComponent,
    FormAddnewsourceComponent,
    ShowTableCategoryPipe,
    ShowSelectedTableCategoryPipe,
    DropdownWrapperComponent,
    SectionInputTypeComponent,
    StepCreationHeaderComponent,
    DndAccordionComponent,
    CommonWrapperComponent,
    ColumnRowsRendererComponent,
    RadioButtonWrapperComponent,
    TrimStringTooltipComponent,
    CallbackPipe,
    HasPropPipe,
    TableRepeatChildComponentComponent,
    CustomLoadingCellRendererComponent,
    CustomLoadingOverlayComponent,
    BannerComponent,
    SafeHtmlPipe,
    SubscriptionEventManagerComponent,
    EnableSubscriptionFeaturePipe,
    TruncatePipe,
    SelectAllTablesPipe,
    GetObjectKeyOrStringPipe,
    JsonParsePipe,
    CommonToastComponent,
    AlertsEventManagerComponent,
    GridCellEditorComponent,
    FrequencySelectTypeComponent,
    CronFrequencyTypeComponent,
    CommonSidebarComponent,
    CronPluginComponent,
    ChipComponent,
    JobHeaderDatePipe,
    ActionRequiredStatusComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    MatListModule,
    MatSortModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatBadgeModule,
    MatStepperModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    ClipboardModule,
    CdkAccordionModule,
    ScrollingModule,
    VirtualScrollerModule,
    CustomCronEditorModule,
    NgSelectModule,
    FormlyMatDatepickerModule,
    FormlyMatSliderModule,
    NgxSliderModule,
    FormlyModule.forRoot({
      validators: [
        { name: 'existingIntegrationName', validation: existingIntegrationNameValidation },
        {name: 'existingTemplateName', validation: existingTemplateNameValidation},
        { name: 'checkClonedIntegrationName', validation: cloneIntegrationNameValidation },
        { name: 'checkSpecialCharacters', validation: textWithUnderScoreValidation },
        { name: 'regexInvalid', validation: (c) => regexValidator(c as any) },
        { name: 'isUnique', validation: validateUniqueValue },
        { name: 'spaceValidator', validation: spaceValidator },
        { name: 'checkCronExpression', validation: cronValidator}
      ],
      validationMessages: [
        { name: 'existingIntegrationName', message: 'Integration name already exists' },
        { name: 'existingTemplateName', message: 'Template name already exists' },
        { name: 'checkClonedIntegrationName', message: 'Change Integration name to proceed.' },
        { name: 'checkCronExpression', message: 'Invalid Cron Expression'},
        { name: 'checkSpecialCharacters', message: textValidatorMessage },
        { name: 'required', message: requiredValidatorMessage },
        { name: 'regexInvalid', message: regexValidatorMessage },
        { name: 'maxlength', message: maxlengthValidationMessage },
        { name: 'isUnique', message: validateUniqueMessage },
        { name: 'spaceValidator', message: spaceValidatorMessage },
      ],
      wrappers: [
        { name: 'wrapper', component: FormFieldsWrapperComponent },
        { name: 'table-selection-wrapper', component: TableSelectionFieldsWrapperComponent },
        { name: 'full-table-wrapper', component: CheckboxWrapperComponent },
        { name: 'accordion-wrapper', component: AccordionWrapperComponent },
        { name: 'dropdown-wrapper', component: DropdownWrapperComponent },
        { name: 'radio-wrapper', component: RadioButtonWrapperComponent },
        { name: 'common-wrapper', component: CommonWrapperComponent }

      ],
      types: [
        {
          name: 'ng-select',
          component: NgSelectTypeComponent,
          wrappers: ['wrapper']
        },
        { name: 'table-repeat', component: TableRepeatChildComponentComponent },
        { name: 'column-accordion', component: ColumnAccordionTypeComponent },
        { name: 'accordion', component: AccordionTypeComponent },
        { name: 'dnd-accordion', component: DndAccordionComponent },
        { name: 'section-input-type', component: SectionInputTypeComponent },
        { name: 'custom-slider', component: SliderTypeComponent },
        {
          name: 'ngx-slider',
          component: CustomSliderTypeComponent,
        },
        { name: 'history-years', component: HistoryYearsTypeComponent },
        {
          name: 'virtual-scroll-grid',
          component: VirtualScrollGridFieldTypeComponent,
          defaultOptions: {
            props: {
              width: '100%',
              height: '400px',
            },
          },
        },
        {
          name: 'cron-frequency',
          component: CronFrequencyTypeComponent,
        },
        {
          name: 'frequency-select-type',
          component: FrequencySelectTypeComponent
        }
      ]
    }),
    FormlyMaterialModule,
    FormlySelectModule,
    FormlyMatToggleModule
  ],
  exports: [  AvailableTablesListComponent, DestinationRenderComponent, HeaderComponent,
    EnableTemplateFeaturePipe, EnableTemplateActionsPipe, IncludesPipe, HasPropPipe, StepCreationHeaderComponent, CallbackPipe,
    BannerComponent, SafeHtmlPipe, SubscriptionEventManagerComponent, EnableSubscriptionFeaturePipe, TruncatePipe, SelectAllTablesPipe, GetObjectKeyOrStringPipe, JsonParsePipe,AlertsEventManagerComponent,ChipComponent, JobHeaderDatePipe, ActionRequiredStatusComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    AppSwitcherService,
    CallbackPipe,
    EnableTemplateActionsPipe
  ]
})
export class SharedModule { }
